<app-card appVisible [visible$]="visible$">
  <div class="d-flex flex-column h-100 w-100 align-items-center">
    <h5><i class="bi" [class]="icon"></i>{{ title }}</h5>
    @if (!loading && !error) {
      <div class="d-flex w-100" [class.hide]="empty">
        <div class="position-relative">
          <canvas class="h-100" [id]="canvasId">{{ chart }}</canvas>
          <div class="donut-inner text-center text-body-secondary">
            <h6>Totaal</h6>
            <p class="fw-bold">{{ total | appNumber }} {{ unit }}</p>
          </div>
        </div>
        <div
          id="legend"
          class="legend-container"
          [innerHTML]="legendHtml"
          (click)="onLegendClick($event)"
          (keypress)="onLegendClick($event)"
          tabindex="0"
        ></div>
      </div>
    }
    @if (loading) {
      <div class="d-flex w-100 placeholder-glow">
        <div class="canvas placeholder"></div>
        <div class="legend-container">
          <ul>
            <div class="legend-value">
              <div class="legend-icon placeholder"></div>
              <span class="legend-text placeholder"></span>
            </div>
            <div class="legend-value">
              <div class="legend-icon placeholder"></div>
              <span class="legend-text placeholder"></span>
            </div>
          </ul>
        </div>
      </div>
    }
    @if (!loading && empty) {
      <app-message>Geen data beschikbaar</app-message>
    } @else if (error) {
      <app-error-message [error]="error"></app-error-message>
    }
  </div>
</app-card>
